import { ref } from 'vue';

const isFraudAlertOpen = ref(false);
const fraudMessage = ref('');

export const useFraudAlert = () => {
    const showFraudAlert = (message: string) => {
        document.body.style.overflow = 'hidden';
        fraudMessage.value = message;
        isFraudAlertOpen.value = true;
    };

    const dismissFraudAlert = () => {
        document.body.style.overflow = '';
        isFraudAlertOpen.value = false;
        fraudMessage.value = '';
    };

    return {
        isFraudAlertOpen,
        fraudMessage,
        showFraudAlert,
        dismissFraudAlert,
    };
};